class LocalStorageKeys {
  static clientToken = "ghkjhfdkivhgrowihgiot-ioyrfiyityuifkymujydgrfyhjg";
}
export default LocalStorageKeys;
